import classNames from "classnames";
import { formatDecimalPlace } from "common/formatters";
import React from "react";
import BidRow from "./bidRow";

export function renderFuturesChange(bidRow: BidRow): React.ReactNode {
    return <span className={classNames({positive: bidRow.futuresChange > 0, negative: bidRow.futuresChange < 0})}>
        {bidRow.futuresChange != null ? formatDecimalPlace(bidRow.futuresChange) : '--'}
    </span>
}